import { Accordion, AccordionItem } from '@jouzen/ecom-components/v4/Accordion';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';

import { igShopSteps } from '../_data/stepSectionData';

const onAccordionOpenChange = (newIndex: number | null) => {
  // Only call analytics track when a new section is opened
  if (newIndex !== null) {
    void window.ouraAnalytics.track(EventType.ModuleClicked, {
      action: 'expand section',
      location: 'meta shop what to expect',
    });
  }
};

const StepSection = () => {
  const t = useTranslations();
  return (
    <div data-cy="step-section">
      <Motion
        initial={{ opacity: 0 }}
        transition={{ delay: 0.35, duration: 0.5 }}
        viewport={{ amount: 0.5, once: true }}
        whileInView={{ opacity: 1 }}
      >
        <Accordion
          className="gap-4"
          defaultOpenIndex={null} // No section open by default
          headerClassName="md:text-xl font-bold pr-4"
          onOpenChange={onAccordionOpenChange}
        >
          {igShopSteps.map(({ answer, id, question, icon }) => (
            <AccordionItem header={t(question)} icon={icon} key={id}>
              <div className="lg:text-base" data-cy={id}>
                <RichText messageKey={answer} />
              </div>
            </AccordionItem>
          ))}
        </Accordion>
      </Motion>
    </div>
  );
};
export default StepSection;
